import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView, disableGA } from '../utils/analytics';

function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Проверяем согласие на аналитические cookies
    const checkConsent = () => {
      try {
        const cookieConsent = localStorage.getItem('cookieConsent');
        if (!cookieConsent) {
          disableGA();
          return false;
        }
        const preferences = JSON.parse(cookieConsent);
        if (preferences.analytics === true) {
          initGA();
          return true;
        } else {
          disableGA();
          return false;
        }
      } catch (e) {
        disableGA();
        return false;
      }
    };

    // Инициализация при монтировании и отслеживание изменений маршрута
    const hasConsent = checkConsent();
    if (hasConsent) {
      trackPageView(location.pathname + location.search);
    }

    // Слушаем изменения в localStorage для обновления согласия
    const handleStorageChange = (e) => {
      if (e.key === 'cookieConsent') {
        checkConsent();
        if (checkConsent()) {
          trackPageView(location.pathname + location.search);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Также слушаем события на том же окне (для случаев, когда согласие меняется в том же окне)
    const handleConsentChange = () => {
      setTimeout(() => {
        checkConsent();
        if (checkConsent()) {
          trackPageView(location.pathname + location.search);
        }
      }, 100);
    };

    // Создаем кастомное событие для отслеживания изменений согласия
    window.addEventListener('cookieConsentChanged', handleConsentChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('cookieConsentChanged', handleConsentChange);
    };
  }, [location]);

  return null;
}

export default GoogleAnalytics;
